import { FC, useState } from "react";
import { EmptyImage } from "../Skeleton/styled";
import { StyledImage } from "./styled";

interface GameImageProps {
  imageUrl?: string;
  altText: string;
  width: string;
  height: string;
}

const GameImage: FC<GameImageProps> = ({
  imageUrl,
  altText,
  width,
  height,
}) => {
  const [imageError, setImageError] = useState(false);
  const [isLoading, setIsLoading] = useState(true);

  if (!imageUrl && !isLoading) {
    return (
      <EmptyImage width={width} height={height}>
        No Image
      </EmptyImage>
    );
  }

  return (
    <>
      {isLoading && <EmptyImage width={width} height={height} />}
      <StyledImage
        src={imageUrl}
        alt={altText}
        width={width}
        height={height}
        style={{ display: isLoading ? "none" : "block" }}
        onLoad={() => setIsLoading(false)}
        onError={() => {
          setImageError(true);
          setIsLoading(false);
        }}
      />
      {imageError && (
        <EmptyImage width={width} height={height}>
          No Image
        </EmptyImage>
      )}
    </>
  );
};

export default GameImage;
